import React, { useState, useEffect, useRef } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Footer } from "../../layouts/footer";
import { Eye, CreditCard } from "lucide-react";
import axios from "axios";
import $ from "jquery";
import "datatables.net-dt/css/dataTables.dataTables.min.css";
import DataTable from "datatables.net-dt";
import config from "../../../config";

const OrderdItems = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const tableRef = useRef(null);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOrders = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await axios.get(`${config.baseURL}/orderditems/${id}`);
        const data = response.data;

        if (Array.isArray(data)) {
          setOrders(data);
          setTimeout(() => {
            // Initialize DataTables only if not already initialized
            if (!$.fn.DataTable.isDataTable(tableRef.current)) {
              $("#ordersTable").DataTable({
                responsive: true,
                scrollX: true,
                autoWidth: false,
                fixedColumns: true,
                pageLength: 10,
                lengthMenu: [5, 10, 25, 50, 100],
                dom: '<"top"lf>rt<"bottom"ip>',
                language: {
                  search: "_INPUT_",
                  searchPlaceholder: "Search products...",
                },
                initComplete: function () {
                  this.api().columns.adjust();
                },
              });
            }
          }, 0);
        } else {
          console.error("Unexpected response format:", data);
          setOrders([]);
          setError("Received unexpected data format from the server.");
        }
      } catch (err) {
        console.error("Error fetching orders:", err);
        setOrders([]);
        setError("Failed to fetch order items. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();

    return () => {
      const table = $("#ordersTable").DataTable();
      if (table) {
        table.destroy();
      }
    };
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center">
        <p className="text-xl">Loading order items...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center">
        <p className="text-xl text-red-500">{error}</p>
      </div>
    );
  }
  return (
    <div className="min-h-screen text-black dark:text-white flex flex-col items-center">
      <div className="w-full bg-white dark:bg-gray-900 rounded-lg shadow-xl overflow-hidden mb-8">
        <div className="px-6 py-5 border-b dark:border-gray-700 flex justify-between items-center">
          <div>
            <p className="text-2xl font-bold text-black dark:text-white">Order Items</p>
            <p className="mt-1 text-gray-400">
              View and manage all items in this order.
            </p>
          </div>
          <Link to={`/admin/paymentdetails/${id}`} class="px-4 py-2 flex gap-2 justify-center items-center bg-gray-600 text-white rounded hover:bg-gray-700">
            <CreditCard size={20} />
            Payment Details
          </Link>
        </div>
        <div className="p-6">
          <div className="relative overflow-x-auto shadow-md rounded-lg">
            <table
              id="ordersTable"
              className="min-w-full divide-y divide-gray-700 text-sm text-gray-700 dark:text-gray-300"
            >
              <thead className="bg-gray-100 dark:bg-gray-800">
                <tr>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                  >
                    ID
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                  >
                    Product Name
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                  >
                    Quantity
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                  >
                    Unit Price
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-700">
                {orders.length > 0 ? (
                  orders.map((item, index) => (
                    <tr
                      key={`${item.id}-${index}`}
                      className="transition-colors duration-150 hover:bg-gray-50 dark:hover:bg-gray-700 border-b dark:border-gray-700"
                    >
                      <td className="px-6 py-4 whitespace-nowrap text-left text-sm font-medium text-gray-600 dark:text-gray-300">
                        {index + 1+'.'}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-left text-sm font-medium text-gray-600 dark:text-gray-300">
                        {item.product_name || "N/A"}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-left text-sm font-medium text-gray-600 dark:text-gray-300">
                        {item.quantity || "N/A"}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-left text-sm font-medium text-gray-600 dark:text-gray-300">
                        {item.unit_price || "N/A"}
                      </td>
                      <td className="px-4 py-3 text-center">
                        <div className="flex justify-center">
                          <button
                            onClick={(e) => {
                              e.preventDefault();
                              navigate(
                                `/admin/orderdproduct/${item.product_id}`
                              );
                            }}
                            className="bg-green-100 text-green-700 p-2 rounded-full hover:bg-green-200 dark:hover:bg-green-900 transition"
                            title="View Product"
                          >
                            <Eye size={20} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="5"
                      className="px-6 py-4 whitespace-nowrap text-center text-lg text-gray-400"
                    >
                      No items found in this order.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default OrderdItems;
